export default __webpack_public_path__ + "static/media/1_0154.95cd4787.webp";